module.exports = __webpack_public_path__ + "img/Ellipse 484.2703ea06.svg";